import { SVGProps } from 'react'

export const LineChild = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={24}
		height={24}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M10.426 13.199a2.126 2.126 0 0 0-2.124-2.124 2.126 2.126 0 0 0-2.124 2.124h1.289a.836.836 0 0 1 1.67 0z"
			fill="currentColor"
		/>
		<path
			d="M10.426 13.199a2.126 2.126 0 0 0-2.124-2.124 2.126 2.126 0 0 0-2.124 2.124h1.289a.836.836 0 0 1 1.67 0z"
			fill="#000"
			fillOpacity={0.2}
		/>
		<path
			d="M15.698 11.075a2.126 2.126 0 0 0-2.124 2.124h1.29a.836.836 0 0 1 1.669 0h1.289a2.126 2.126 0 0 0-2.124-2.124"
			fill="currentColor"
		/>
		<path
			d="M15.698 11.075a2.126 2.126 0 0 0-2.124 2.124h1.29a.836.836 0 0 1 1.669 0h1.289a2.126 2.126 0 0 0-2.124-2.124"
			fill="#000"
			fillOpacity={0.2}
		/>
		<path
			d="M12 16.97c-.815 0-1.58-.436-1.994-1.14l-1.11.655A3.62 3.62 0 0 0 12 18.259a3.62 3.62 0 0 0 3.105-1.774l-1.11-.655A2.33 2.33 0 0 1 12 16.97"
			fill="currentColor"
		/>
		<path
			d="M12 16.97c-.815 0-1.58-.436-1.994-1.14l-1.11.655A3.62 3.62 0 0 0 12 18.259a3.62 3.62 0 0 0 3.105-1.774l-1.11-.655A2.33 2.33 0 0 1 12 16.97"
			fill="#000"
			fillOpacity={0.2}
		/>
		<path
			d="M22.161 10.916a2.85 2.85 0 0 0-1.485-.787A9.13 9.13 0 0 0 12 3.823h-.432a1.884 1.884 0 0 1-1.882-1.882h-1.29c0 .704.232 1.355.622 1.882h-.409a1.884 1.884 0 0 1-1.882-1.882H5.438c0 1.4.913 2.591 2.175 3.01a9.12 9.12 0 0 0-4.289 5.178 2.85 2.85 0 0 0-1.486.787A2.85 2.85 0 0 0 1 12.941c0 .755.291 1.468.82 2.006a2.85 2.85 0 0 0 1.504.807A9.13 9.13 0 0 0 12 22.059a9.13 9.13 0 0 0 8.676-6.305 2.85 2.85 0 0 0 1.504-.807c.529-.538.82-1.25.82-2.006 0-.764-.298-1.483-.839-2.025m-1.993 3.599-.484.009-.126.467A7.84 7.84 0 0 1 12 20.77a7.84 7.84 0 0 1-7.558-5.78l-.126-.466-.484-.01a1.58 1.58 0 0 1-1.543-1.573 1.57 1.57 0 0 1 1.543-1.573l.484-.01.126-.467A7.84 7.84 0 0 1 12 5.112c1.165 0 2.113.948 2.113 2.113A2.115 2.115 0 0 1 12 9.338a2.115 2.115 0 0 1-2.113-2.113H8.598A3.406 3.406 0 0 0 12 10.627a3.406 3.406 0 0 0 3.402-3.402 3.4 3.4 0 0 0-.344-1.489 7.83 7.83 0 0 1 4.5 5.155l.126.467.484.01c.408.007.793.17 1.082.46.297.297.461.693.461 1.113 0 .852-.692 1.558-1.543 1.574"
			fill="currentColor"
		/>
		<path
			d="M22.161 10.916a2.85 2.85 0 0 0-1.485-.787A9.13 9.13 0 0 0 12 3.823h-.432a1.884 1.884 0 0 1-1.882-1.882h-1.29c0 .704.232 1.355.622 1.882h-.409a1.884 1.884 0 0 1-1.882-1.882H5.438c0 1.4.913 2.591 2.175 3.01a9.12 9.12 0 0 0-4.289 5.178 2.85 2.85 0 0 0-1.486.787A2.85 2.85 0 0 0 1 12.941c0 .755.291 1.468.82 2.006a2.85 2.85 0 0 0 1.504.807A9.13 9.13 0 0 0 12 22.059a9.13 9.13 0 0 0 8.676-6.305 2.85 2.85 0 0 0 1.504-.807c.529-.538.82-1.25.82-2.006 0-.764-.298-1.483-.839-2.025m-1.993 3.599-.484.009-.126.467A7.84 7.84 0 0 1 12 20.77a7.84 7.84 0 0 1-7.558-5.78l-.126-.466-.484-.01a1.58 1.58 0 0 1-1.543-1.573 1.57 1.57 0 0 1 1.543-1.573l.484-.01.126-.467A7.84 7.84 0 0 1 12 5.112c1.165 0 2.113.948 2.113 2.113A2.115 2.115 0 0 1 12 9.338a2.115 2.115 0 0 1-2.113-2.113H8.598A3.406 3.406 0 0 0 12 10.627a3.406 3.406 0 0 0 3.402-3.402 3.4 3.4 0 0 0-.344-1.489 7.83 7.83 0 0 1 4.5 5.155l.126.467.484.01c.408.007.793.17 1.082.46.297.297.461.693.461 1.113 0 .852-.692 1.558-1.543 1.574"
			fill="#000"
			fillOpacity={0.2}
		/>
	</svg>
)
